module.exports = "<Spinner animation=\"border\" role=\"status\">\n  <span className=\"visually-hidden\">Loading...</span>\n</Spinner>;\n"